import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const EditGroupsModal = ({ isOpen, user, allGroups, onSave, onCancel }) => {
  const [selectedGroups, setSelectedGroups] = useState([]);

  useEffect(() => {
    if (isOpen && user) {
      // Initialize with user's current groups
      setSelectedGroups(user.groupIds || []);
    }
  }, [isOpen, user]);

  if (!isOpen || !user) return null;

  const handleToggleGroup = (groupId) => {
    setSelectedGroups((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  };

  const handleSave = () => {
    onSave(user.id, selectedGroups);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">
            Edit Groups for {user.displayName}
          </h3>
          <button
            onClick={onCancel}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="p-6">
          <div className="space-y-2 max-h-96 overflow-y-auto">
            {allGroups.length === 0 ? (
              <p className="text-gray-500 text-sm">No groups available</p>
            ) : (
              allGroups.map((group) => (
                <label
                  key={group.id}
                  className="flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedGroups.includes(group.id)}
                    onChange={() => handleToggleGroup(group.id)}
                    className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                  />
                  <span className="text-gray-900">{group.name}</span>
                </label>
              ))
            )}
          </div>
        </div>

        <div className="flex justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditGroupsModal;
